import { RightOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { MobileOpenClassSessionDetails } from '../types/OpenClassSession';
import { InfoCell } from '../views/CourseInstanceDetails';
import Failed from '../resources/img/failed.svg';
import Participated from '../resources/img/participated.svg';
import Passed from '../resources/img/passed.svg';

type OpenClassSessionAttendeesInfoCellProps = {
  session: MobileOpenClassSessionDetails;
};

const OpenClassSessionAttendeesInfoCell: React.FC<
  OpenClassSessionAttendeesInfoCellProps
> = ({ session }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const hasEnded = dayjs().isAfter(dayjs(session.endAt));

  return (
    <InfoCell
      title={t('common.attendees')}
      contentClassName="bg-gray-200 rounded-lg cursor-pointer"
      contentOnClick={() =>
        navigate(`/open-classes/sessions/${session.id}/participants`, {
          state: { prevPage: location.pathname },
        })
      }>
      <div className="flex items-center justify-between">
        {hasEnded ? (
          <div className="flex flex-col gap-2 ml-2 my-3">
            <div className="flex flex-row items-center gap-2">
              <img src={Participated} className="w-4" alt="" />
              {t('views.CourseInstanceAttendees.participatedAttendees', {
                attendeeCount: session.presentCount,
                totalCount: session.participantCount,
              })}
            </div>
            <div className="flex flex-row items-center gap-2">
              <img src={Passed} className="w-4" alt="" />
              {t(
                'views.CourseInstanceAttendees.participatedAndPassedAttendees',
                {
                  count: session.passedCount,
                },
              )}
            </div>
            <div className="flex flex-row items-center gap-2">
              <img src={Failed} className="w-4" alt="" />
              {t(
                'views.CourseInstanceAttendees.participatedAndFailedAttendees',
                {
                  count: session.failedCount,
                },
              )}
            </div>
          </div>
        ) : (
          <div className="text-blueGrayDark font-medium pl-2 py-3">
            {t('views.CourseInstanceAttendees.attendees')}
            &nbsp;{session.participantCount}
          </div>
        )}
        <RightOutlined className="mr-2 text-base" />
      </div>
    </InfoCell>
  );
};

export default OpenClassSessionAttendeesInfoCell;
